export default function VideoUnavailable() {
  return (
    <div className="text-muted-foreground bg-secondary flex aspect-video w-full flex-col items-center justify-center rounded-sm p-4 text-center text-sm">
      Video not available for playback.
    </div>
  )
}
